function getNewProducts() {
  const path = "/products/popular_web.json";

  var since = 1;
  if (!window._PRODUCTION) since = 90;

  return $.ajax({
    url: window._BASEURL + path,
    data: { since: since },
    method: "GET",
    headers: getHeaders()
  });
}
function processProducts(data) {
  $('#new-items-homepage').empty();
  var product_ids_to_check = [];
  for (var i = 0; i < 4; i++) {
    if (data.products[i]) {
      drawProduct(data.products[i]);
      product_ids_to_check.push(data.products[i].shopify_product_id);
    }
  }
  loadMetadata("#new-items-homepage").done(processMetadata);
  $(".super-likes").dialog({
    autoOpen: false,
    resizable: false,
    modal: true,
    show: { effect: "fadeIn", duration: 200 },
    hide: { effect: "fadeOut", duration: 200 }
  });
  $(".modal-close").click(function() {
    $(this)
      .closest(".modal")
      .dialog("close");
  });
}
function drawProduct(product) {
  var new_product =
    '<div data-shopify-product-id="' +
    product.shopify_product_id +
    '" class="grid__item large--one-quarter medium--one-half small--one-half indv-product is_it_here">' +
    '<a href="' +
    product.shopify_product_url +
    '" class="grid__image">' +
    '<div class="image" style="display:block">' +
    '<a href="' +
    product.shopify_product_url +
    '">' +
    '<img class="first test" src="' +
    (product.primary_image_asset_id
      ? RO.DAM.namedImageUrl(product.primary_image_asset_id, "large")
      : product.shopify_mockup_large_url) +
    '" alt="' +
    product.title +
    '" />' +
    "</a>" +
    "</div>" +
    //       '<div class="social-container">'+
    '<a class="likes fa fa-heart-o" aria-hidden="true"><span>' +
    product.num_likes +
    "</span></a>" +
    '<a class="super_likes fa fa-star-o" aria-hidden="true"><span>' +
    product.num_super_likes +
    "</span></a>" +
    '<a class="comments fa fa-comment-o" aria-hidden="true" href="' +
    product.shopify_product_url +
    '#comments"><span>' +
    product.comment_count +
    "</span></a>" +
    //       '</div>'+
    '<div class="indv-product-info">' +
    '<a href="' +
    product.shopify_product_url +
    '">' +
    '<h4 class="h5">' +
    product.title +
    "</h4>" +
    "</a>" +
    '<a  class="underline"  href="/a/users/' +
    product.owner.username +
    '">' +
    "<h6>" +
    product.owner.username +
    "</h6>" +
    "</a>" +
    '<a href="' +
    product.shopify_product_url +
    '">' +
    "<p>" +
    formatMoney(product.min_price) +
    "</p>" +
    "</a>" +
    "</div>" +
    "</a>" +
    "</div>";
  $("#new-items-homepage").append(new_product);
}
